import * as React from 'react'
import { useTranslation } from "react-i18next"
import styled, { css } from "styled-components"
import { ConversationMessageRequestEmail } from '../../../../../types'
import { ConversationsController } from '../../../../controllers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px 24px 24px;
  margin-left: 0px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 1.4;
  color: rgb(20, 22, 26);
  overflow: hidden;
  border: 1px solid rgb(229, 229, 229);
`

const FormTitle = styled.div`
  margin-bottom: 6px;
  font-size: 14px;
  line-height: 24px;
  max-height: 48px;
  color: rgb(20, 22, 26);
  transition: opacity 300ms 1000ms, max-height 400ms 1000ms;
`

const EmailFormSubmit = styled.div`
  position: relative;
  flex: 0 0 auto;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 40px;
  height: 40px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  background: ${({ theme }) => theme.color.background};
  color: ${({ theme }) => theme.color.backgroundText};
  user-select: none;
`

const EmailForm = styled.form<{ hasValue: boolean, admin: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    width: 100% !important;
    padding: 11px 2px 11px 16px !important;
    box-sizing: border-box !important;
    font-size: 14px !important;
    box-shadow: rgba(9, 14, 21, 0.06) 0px 1px 3px 0px inset;
    border: 1px solid rgb(229, 229, 229) !important;
    color: rgb(20, 22, 26) !important;
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    background: rgb(245, 245, 245) !important;
    appearance: none !important;
    height: 40px !important;
    border-right: none !important;

    &:focus, &:active {
      outline: none !important;
      box-shadow: rgba(9, 14, 21, 0.06) 0px 1px 3px 0px inset !important;
      border-color: rgb(229, 229, 229) !important;
    }

    ${props => (props.hasValue || props.admin) && css`
      cursor: disabled !important;

      border-top-right-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
    `}
  }

  ${props => (props.hasValue || props.admin) && css`
    ${EmailFormSubmit} {
      display: none;
    }
  `}
`



interface IProps {
  message: ConversationMessageRequestEmail
  admin: boolean
}

const RequestEmail = (props: IProps) => {
  const { message, admin } = props
  const { t } = useTranslation()
  const hasValue = Boolean(message.email)

  const [email, setEmail] = React.useState(message.email)

  React.useEffect(() => {
    setEmail(message.email)
  }, [message.email])

  const onEmailChange = (e) => {
    setEmail(e.currentTarget.value)
  }

  const onSubmit = async (e) => {
    try {
      e.preventDefault()

      await ConversationsController.form(message.conversation_id, [
        { identifier: 'email', value: email, message_id: message.id }
      ])
    } catch (ex) {
      console.error(ex)
    }
  }

  return (
    <Container>
      <FormTitle>
        {hasValue ? t('Message::You will be notified here and by email') : t('Message::Get notified by email')}
      </FormTitle>
      <EmailForm hasValue={hasValue} admin={admin} onSubmit={onSubmit}>
        <input
          type='email'
          placeholder='email@example.com'
          onChange={onEmailChange}
          disabled={hasValue || admin}
          value={email}
          required
        />

        <EmailFormSubmit onClick={onSubmit}>
          <input type='submit' style={{ display: 'none' }} />
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z" fill="currentColor"></path></svg>
        </EmailFormSubmit>
      </EmailForm>
    </Container>
  )
}

export default RequestEmail